import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServiceSection from './components/ServiceSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <StatsSection />
      <ServiceSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </main>
  );
}